import { FC } from "react";

import { Box } from "@chakra-ui/react";

import { IconButton } from "@components/buttons";
import Icon from "@components/Icon";
import responsiveStyle from "@lib/theme/responsiveStyle";

import useUserPosition from "../hooks/useUserPosition";

type TUserPositionButtonProps = {
  map?: H.Map;
  selectedLockerId?: string;
  hasPositionInit?: boolean;
};

const UserPositionButton: FC<TUserPositionButtonProps> = ({ map, selectedLockerId, hasPositionInit }) => {
  const { updateUserPosition } = useUserPosition(map, selectedLockerId, hasPositionInit);

  const handlePositionClicked = () => {
    updateUserPosition();
  };
  return (
    <Box
      position="absolute"
      bottom={responsiveStyle({ mobile: "2rem", desktop: "1.5rem" })}
      right={responsiveStyle({ mobile: "1rem", desktop: "0.5rem" })}
    >
      <IconButton
        size="sm"
        variant="transparent"
        icon={<Icon icon="location" />}
        sx={{ bg: "white", borderRadius: "0.25rem" }}
        onClick={handlePositionClicked}
      />
    </Box>
  );
};
export default UserPositionButton;
